<template>
    <z-basePage :title="'罚单设置'">
        <div class="tab-title">
            <div class="tab-btn" :class="{active:activeIndex==0}" @click="changeTab(0)">系统罚单</div>
            <div class="tab-btn" :class="{active:activeIndex==1}" @click="changeTab(1)">人工罚单</div> 
        </div>

        <div class="tab">
            <!-- 系统罚单 -->
            <div class="tab-main" v-show="activeIndex == 0">
                <div class="back-list">
                    <div class="list-head">
                        <!-- <el-checkbox v-model="allchoose"></el-checkbox> -->
                        <div>编号</div>
                        <div>罚单类型</div>
                        <div>罚单金额</div>
                        <div>适用对象</div>
                        <div>罚单说明</div>
                        <div>开关</div>
                        <div>操作</div>
                    </div>
                    <z-scrollDiv >
                        <div class="list-item"  v-for="(item,index) in systemTicket" :key="item.id">
                            <div>{{ `C0${index+1}` }}</div>
                            <div>{{ item.ticket_name }}</div>
                            <div>{{ item.ticket_amount | ticket(item.ticket_name) }}</div>                                
                            <div>{{ item.ticket_target | ticketTar }}</div>                                
                            <div class="overhide">{{ item.ticket_description }}</div>
                            <div><el-switch v-model="item.ticket_switch" on-color="#34b96c" on-text="" off-text="" @change="turn(item,index)"></el-switch></div>
                            <div>
                                <span class="blue" @click="link(item.id)">{{ item.ticket_name | btn }}</span>
                            </div> 
                        </div>
                    </z-scrollDiv>
                </div>
                <div class="tip">系统罚单编号以 "C" 开头</div>

            </div>
            
            <!-- 人工罚单 -->
            <div class="tab-main" v-show="activeIndex == 1">
                <div class="btns-top">
                    <div class="back-btn blue" @click="link(0)">创建</div>
                </div>
                <div class="back-list page">
                    <div class="list-head">
                        <!-- <el-checkbox v-model="allchoose"></el-checkbox> -->
                        <div>编号</div>
                        <div>罚单类型</div>
                        <div>罚单金额</div>
                        <div>适用对象</div>
                        <div>罚单说明</div>
                        <div>开关</div>
                        <div>操作</div>
                    </div>
                    <z-scrollDiv class="main-special">
                        <div class="list-item"  v-for="(item,index) in personTicket" :key="item.id">
                            <div>{{ `P0${index+1}` }}</div>
                            <div class="overhide" :title="item.ticket_name">{{ item.ticket_name }}</div>
                            <div>{{ item.ticket_amount | ticket(item.ticket_name) }}</div>                                
                            <div>{{ item.ticket_target | ticketTar }}</div>                                
                            <div class="overhide">{{ item.ticket_description }}</div>
                            <div><el-switch v-model="item.ticket_switch" on-color="#34b96c" on-text="" off-text="" @change="turn(item,index)"></el-switch></div>
                            <div>
                                <span class="blue" @click="link(item.id)">编辑</span>
                            </div> 
                        </div>
                        <z-noData :list="personTicket"></z-noData>
                        <div class="tip" v-show="personTicket.length != 0">人工罚单编号以 "P" 开头</div>
                    </z-scrollDiv>
                </div>

            </div>
            
        </div>
    </z-basePage>
</template>

<script>
    import { mapState } from "vuex"

    export default {
        data(){
            return {
                systemTicket:[],   //系统罚单列表
                personTicket:[],   //人工罚单列表
            }
        },
        computed:{
            activeIndex(){
                return this.$route.query.tab || 0;
            },
           
        },
        created(){
            this.getSystemTicket();
            this.getPersonTicket();
        },

        filters:{  //过滤器
            btn(name){
                if(name == '任务延期' || name == '任务超期'){
                    return "查看"
                }
                return '编辑';
            },
        },
        methods:{
            getSystemTicket(){  //获取系统罚单
                let url = `api/clerk/cfg_ticket/system`;
                this.$http.get(url).then(res=>{
                    if(res.status == 200){
                        this.systemTicket = res.res_data;
                    }
                });
            },
            getPersonTicket(){  //获取人工罚单
                // let url = `api/clerk/cfg_ticket/personal`;
                let url = `api/admin/cfg_ticket/personal`;
                this.$http.get(url).then(res=>{
                    if(res.status == 200){
                        this.personTicket = res.res_data;
                    }
                });
            },

            changeTab(val){  //记录激活的tab序号
                this.$router.replace({
                    name:'back-setting-ticket',
                    query:{
                        tab:val
                    },
                });    
            },
            link(id){ 
                let str = this.$crypto.encrypt(id);
                this.$router.push({
                    name:'back-setting-addTicket',
                    params:{
                        id:str
                    }
                })
            },
            turn(item,index){   //开关控制
                if(item.ticket_switch){
                    let url = `api/admin/cfg_ticket/${item.id}/switch_on`
                    this.$http.put(url).then(res=>{
                        if(res.status == 200){
                            this.successTip("罚单已启用");
                        }else{
                            item.ticket_switch = false;
                        }
                    }).catch(err=>{
                        this.errorTip("操作失败");
                        item.ticket_switch = false;
                    });
                }else{
                    let url = `api/admin/cfg_ticket/${item.id}/switch_off`
                    this.$http.put(url).then(res=>{
                        if(res.status == 200){
                            this.successTip("罚单已关闭");
                        }else{
                            item.ticket_switch = true;
                        }
                    }).catch(err=>{
                        this.errorTip("操作失败");
                        item.ticket_switch = true;
                    });
                }
            },
        }
    }
</script>

<style lang="less" scoped>
    // @import "~src/assets/less/backless/var.less";
    // .tab-title{
    //     position: relative;
        
    //     overflow: hidden;
    //     margin-bottom: 10px;
    //     .tab-btn{
    //         float: left;
    //         box-sizing: border-box;
    //         width: 95px;
    //         height:30px;
    //         line-height: 28px;
    //         text-align: center;
    //         font-size: 12px;
    //         color:@font_list;
    //         border: 1px solid #d9dfe7;
    //         transition: 0.3s;
    //         user-select: none;
    //         cursor:pointer;
    //         &:hover{
    //             color:@blue;
    //         }
    //         &.active{
    //             color:@blue;
    //             border-color:@blue;
    //         }
    //     }

    //     .tab-btn:nth-of-type(1){
    //         border-top-left-radius: 4px;
    //         border-bottom-left-radius: 4px;
    //     }
    //     .tab-btn:nth-of-type(2){
    //         border-top-right-radius: 4px;
    //         border-bottom-right-radius: 4px;
    //         // transform: translateX(-1px);
    //     }

    //     .back-btn{
    //         position: absolute;
    //         right: 0;
    //         top: 0;
    //     }
    // }

    .back-list{
        .main-special{
            height:calc(~"100% - 40px");
        }
        .tip{
            font-size: 12px;
            color:#aaa;
            margin-top: 10px;
        }
    }

    .tab{
        position: relative;
        height: calc(~"100% - 30px - 10px");
        .tab-main{
            position: absolute;
            width:100%;
            height:100%;
            top:0;
            left:0;
        }
    }


    // 列表项布局
    .list-head,.list-item{
        >div:nth-of-type(1){
            width: 9%;
        }
        >div:nth-of-type(2){
            width: 11%;
            padding-right: 2%;
        }
        >div:nth-of-type(3){
            width: 18%;
        }
        >div:nth-of-type(4){
            width: 12%;
        }
        >div:nth-of-type(5){
            width: 22%;
        }
        >div:nth-of-type(6){
            width: 10%;
            padding-left: 6%;
        }
        >div:last-of-type{
            width: 10%;
            span{
                cursor: pointer;
                display: inline-block;
                &+span{
                    margin-left:10px;
                }
            }
        }
    }
</style>





// WEBPACK FOOTER //
// page-ticket.vue?abaadda6